<template>
	<div class="opts_wrap" v-loading="isLoading">
		<div class="opts_line">
			<div class="con">
				<el-input v-model="name" clearable>
					<p slot="prefix" class="label_title">标题：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">分类：</p>
			<div class="con">
				<el-cascader 
						class="w100"
						v-model="cate_id"
				    placeholder="请选择"
						:props="cateProps"
						clearable
				    filterable>
						</el-cascader>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<div class="s_line">
					<span class="label">运费</span>
					<div class="info">
						<el-radio-group v-model="freight_template_id" size="mini">
							<el-radio :label="0" >包邮</el-radio>
							<el-radio :label="1" >非包邮</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="goods_no" clearable>
					<p slot="prefix" class="label_title">货号：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">货架：</p>
			<div class="con">
				<el-select class="w100" size="small" v-model="stalls_id" placeholder="请选择" clearable>
					<el-option v-for="(item,index) in product_stalls" :key="index" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<el-input v-model="stock_msg" clearable>
					<p slot="prefix" class="label_title">备货提醒：</p>
				</el-input>
			</div>
		</div>
		<div class="opts_line">
			<div class="con">
				<div class="s_line">
					<span class="label">状态</span>
					<div class="info">
						<el-radio-group v-model="status" size="mini">
							<el-radio :label="0" >上架</el-radio>
							<el-radio :label="1" >下架</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		</div>
	
		<div class="btn_wrap">
			<p class="btn" @click="saveBtn()">提交</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import {productLeafCateList,allStallsList} from "../../api/main/ucenter.js";
export default {
	name: "editInfo",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		product: {
			type: Object,
			default: {}
		},
	},
	data() {
		return {
			loading: false,
			name:'',
			goods_no:'',
			stock_msg:'',
			stalls_id:'',
			cate_id: [],
			freight_template_id: 0,
			cateProps: {},
			product_stalls: [],
			status:0,
		};
	},
	
	created(){
		this.init()
	},
	mounted() {
	},
	
	computed:{
		...mapState({
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
		}),
		init(){
			this.loading = false
			this.name = this.product.name
			this.cate_id = this.product.cate_ids
			this.stalls_id = this.product.stalls_id?this.product.stalls_id:''
			this.goods_no = this.product.goods_no?this.product.goods_no:''
			this.stock_msg = this.product.stock_msg?this.product.stock_msg:''
			this.freight_template_id = this.product.freight_template_id
			this.status = this.product.status
			this.cateProps = {
					lazy: true,
					// checkStrictly: true,
					// expandTrigger: 'hover',
					lazyLoad (node, resolve) {
						var cate = node?node:{value:0,level:1};
						var param = {pid:cate.value,level:cate.level+1,is_all:1}
					  	productLeafCateList(param).then(res => {
							if(res.code == 200){
								let list = res.data.cate_list
								console.log('leaf_list:',list.length)
								const nodes = Array.from(list)
									.map(item => ({
										value: item.value,
										label: item.label,
										level: item.level,
										leaf: item.leaf==1?0:1,//0为有下级 1为没有
									}));
								// console.log(nodes)
								resolve(nodes);
							}	
						})
						
					}
				}
			this.getStallsList()
		},
		getStallsList(){
			allStallsList({}).then(res => {
				this.product_stalls = res.data
			})
		},
		
		saveBtn(){
			let param = {
				product_id:this.product.product_id,
				name: this.name,
				cate_id: this.cate_id,
				freight_template_id: this.freight_template_id,
				stalls_id: this.stalls_id,
				goods_no: this.goods_no,
				stock_msg: this.stock_msg,
				status: this.status
			}
			this.$emit('submit',param)
		},
		
		cancel(){
			this.$emit('close', {})
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;position: relative;}
	.opts_line .txt{width: 80px;text-align: left;font-size: 14px;position: absolute;left: 14px;z-index: 1;color: #C0C4CC;}
	.opts_line .con{flex: 1;width: 0;margin-left: 0px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	.w100{width: 100%;}
	.s_line{padding:0 12px;height: 34px;line-height: 34px;border:1px solid #DCDFE6;border-radius:4px;width: 100%;}
	.s_line .label{color:#C0C4CC;font-size:14px;width: 68px;display:inline-block;}
	.s_line .info{display:inline-block;}
	.el-input{width: 100% !important; }
	
	/deep/.el-input__prefix{left: 15px;}
	/deep/.el-input--small .el-input__inner{padding-left: 76px !important;}
</style>
<style>
	
</style>